var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDmsImport(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 29,
    viewBox: "0 0 20 29",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 22.6V29h2.73c1.94 0 3.33-1.37 3.33-3.2 0-1.82-1.39-3.2-3.33-3.2H0zm2.73 1.29c1.11 0 1.9.74 1.9 1.91s-.79 1.91-1.9 1.91H1.4v-3.82h1.33zM9.94 28.47h1.37l1.3-3.79L13 29h1.42l-.58-6.4h-1.73l-1.43 4.13-1.44-4.13H7.46L6.89 29h1.35l.38-4.2zM19.03 27.2c0 .43-.43.66-1.03.66-.71 0-1.24-.36-1.24-.87h-1.47c0 1.21 1.08 2.11 2.69 2.11 1.61 0 2.51-.84 2.51-2.04 0-.99-.62-1.67-1.94-1.88l-.56-.09c-.88-.14-1.23-.29-1.23-.7 0-.43.44-.66 1.03-.66.65 0 1.1.29 1.1.81h1.43c0-1.27-1.09-2.04-2.54-2.04-1.48 0-2.45.78-2.45 1.98 0 1.03.78 1.72 2.12 1.94l.56.08c.82.14 1.02.35 1.02.7z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M18.75 3.125v13.75c0 1.036-.84 1.875-1.875 1.875H3.125a1.875 1.875 0 0 1-1.875-1.875V3.125c0-1.036.84-1.875 1.875-1.875h13.75c1.036 0 1.875.84 1.875 1.875zm-3.438.625H10.94c-.833 0-1.253 1.01-.663 1.6l1.25 1.25-7.639 7.638a.469.469 0 0 0 0 .663L5.1 16.113c.183.183.48.183.663 0L13.4 8.475l1.25 1.25c.587.587 1.6.174 1.6-.663V4.688a.937.937 0 0 0-.938-.938z",
    transform: "rotate(180 10 10)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDmsImport);
export default __webpack_public_path__ + "static/media/dms-import.17a1bffc56dfe0cd5edac2baaf373032.svg";
export { ForwardRef as ReactComponent };